import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildNavigateToCreatedDashboardSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const DASHBOARD_CREATE_TOOL_NAMES = ['create_dashboard'];

const buildNavigateToCreatedDashboardSubscription = (
    _params: BuildNavigateToCreatedDashboardSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'navigate-to-created-dashboard',
        routePattern: '*',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, routeParams }) => {
            if (!eventMatchesToolNames({ event, toolNames: DASHBOARD_CREATE_TOOL_NAMES })) {
                return false;
            }

            const result = coerceToRecord({ value: event.result });
            const dashboard = coerceToRecord({ value: result.dashboard });
            const dashboardId = getStringValue({ value: dashboard.id });
            const agentId = routeParams.agentId || '';
            return dashboardId !== '' && agentId !== '';
        },
        action: ({ event, navigate, routeParams }) => {
            const result = coerceToRecord({ value: event.result });
            const dashboard = coerceToRecord({ value: result.dashboard });
            const dashboardId = getStringValue({ value: dashboard.id });
            const agentId = routeParams.agentId as string;

            navigate(`/agents/${agentId}/dashboards/${dashboardId}`);
        },
    };
};

export default buildNavigateToCreatedDashboardSubscription;
